import { uri } from '../../api-endpoint';
import {
  ILabelAPIValidationError,
  ILabelFromAPISuccessResponse
} from '../../type-conversion/label/from-api-repsonse';
import { LabelAPIRequestBody } from '../../type-conversion/label/to-api-request-body';
import { createTemplateFn } from '../common';

export const createModelLabel = (token: string) => (modelId: number) =>
  createTemplateFn(
    token,
    uri.modelLabelList(modelId),
    LabelAPIRequestBody,
    ILabelFromAPISuccessResponse,
    ILabelAPIValidationError
  );
